export enum GoogleAnalyticsAction {
    VideoStart = 'video_start',
    VideoPause = 'video_pause',
    VideoResume = 'video_resume',
    VideoEnd = 'video_end',
    VideoSeek = 'video_seek',
    VideoLoaded = 'video_loaded',
    VideoComplete = 'video_complete',
    VideoProgress = 'video_progress',
    Bounce = 'bounce'
}
